<template>
  <div class="ny-pageV2">
    <div class="inner">
      <NavView />
      <NavMarkView columnName="排行榜"/>
      <div class="ranking-page">
        <div class="left">
          <LeftMenu :active="isActive" :data="navData" @columnClick="columnClick" />
        </div>
        <div class="right">
          <div class="right-body">
            <RankHead :title="columnName" :topTxt="20" />
            <div class="rank-body">
              <List :sort="false" :order="true" :id="id" ref="childRef" />
            </div>
          </div>
          <div class="other-router" v-if="otherData.length !==0">
            <div class="ti">更多好书一键探索：</div>
            <div class="columnlist">
              <router-link :to="item.path" class="item" v-for="item of otherData" :key="item.id">{{ item.columnName }}</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavView from "common/NavView";
import NavMarkView from "common/NavMarkView";
import List from "common/List/RankingList";
import LeftMenu from "./components/LeftMenu";
import RankHead from "./components/RankHead";
export default {
  name: "Ranking",
  components: {
    NavView,
    NavMarkView,
    LeftMenu,
    RankHead,
    List,
  },
  data() {
    return {
      isActive: "1",
      navData: [
        { ID: "1", NAME: '飙升榜' },
        { ID: "2", NAME: '收藏榜' },
        { ID: "3", NAME: '荐购榜' },
        { ID: "4", NAME: '阅读榜' },
      ],
      columnName: '飙升榜',
      otherData: [],
      id: "",
    }
  },
  mounted() {
    //alert(window.localStorage.HDSWebNav);
    // var data = JSON.parse(window.localStorage.HDSWebNav);
    // const otherData = data
    //   .filter(item => item.PARENTID === '79e71676369843038602643c9e034581')
    //   .map(item => ({
    //     id: item.ID,
    //     columnName: item.NAVNAME,
    //     path: item.NAVPAGE + '?id=' + item.ID,
    //   }));
    // this.otherData = otherData;
    this.id = this.navData[0].ID;
  },
  methods: {
    columnClick(obj) {
      this.isActive = obj.ID;
      this.navData.map((item) => {
        if (item.ID === obj.ID) {
          this.columnName = item.NAME;
        }
      })
      this.$refs.childRef.load(obj.ID);
    },
  },
}
</script>

<style lang="css" scoped>
.ranking-page,
.other-router {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-wrap: nowrap;
}

.ranking-page {
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  -webkit-box-align: start;
  -ms-flex-align: start;
  -webkit-align-items: flex-start;
  align-items: flex-start;
}

.ranking-page .left,
.ranking-page .right-body {
  background-color: #fff;
  border-radius: 10px;
  margin-bottom: 25px;
}

.ranking-page .left {
  width: 137px;
}

.ranking-page .right {
  width: calc(100% - 157px);
}

.rank-body {
  padding: 10px 20px;
}

.other-router {
  margin-bottom: 25px;
}

.other-router .ti {
  font-weight: bold;
  width: 150px;
  line-height: 25px;
}

.columnlist {
  width: calc(100% - 150px);
}

.columnlist .item {
  display: inline-block;
  cursor: pointer;
  background-color: #ECECEC;
  color: #272636;
  height: 25px;
  line-height: 25px;
  border-radius: 30px;
  padding: 0 15px;
  margin: 0 10px 10px 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/categry/Ranking.vue